import { DATA_GIF_PATH } from "@/app/utils/config";

type SuccessType = "report" | "feedback";

interface UserprofileSuccessfullyProps {
  isOpen: boolean;
  onClose: () => void;
  type: SuccessType;
}

const SUCCESS_CONTENT: Record<
  SuccessType,
  {
    title: string;
    heading: string;
    description: string;
    buttonText: string;
  }
> = {
  report: {
    title: "Issue",
    heading: "Reported Successfully",
    description:
      "Thank you. Our support team will review your request and get back to you shortly.",
    buttonText: "Close",
  },
  feedback: {
    title: "Thank You For",
    heading: "Your Feedback",
    description:
      "Thank you for sharing your feedback. Our team will review it and respond if needed.",
    buttonText: "Close",
  },
};

const UserprofileSuccessfully = ({
  isOpen,
  onClose,
  type,
}: UserprofileSuccessfullyProps) => {
  if (!isOpen) return null;

  const { title, heading, description, buttonText } = SUCCESS_CONTENT[type];

  return (
    <div className="success-overlay">
      <div className="success-modal">
        <div className="success-image">
          <img
            src={`${DATA_GIF_PATH}done_animation.gif`}
            alt="Success"
            className="success-animation"
          />
        </div>

        <h3 className="success-title">{title}</h3>

        <h2 className="success-heading">{heading}</h2>

        <p className="success-description">{description}</p>

        <button className="close-btn" onClick={onClose}>
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default UserprofileSuccessfully;
